<template>
	<div class="main">
		<el-upload
		  class="upload-demo"
		  :action="action"
		  :on-preview="handlePreview"
		  :on-remove="handleRemove"
		  :before-remove="beforeRemove"
		  :on-exceed="handleExceed"
		  :headers="headerObj"
		  >
		  <el-button size="small" type="primary">点击上传</el-button>
		  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
		</el-upload>
	</div>
</template>

<script>
export default{
	name:'Test',
	data(){
		return {
			action:"http://kp.wxq.com/index/Upload/Excel",
			headerObj:{
				token:sessionStorage.getItem("token")
			},
		}
	},
	methods:{
		
		handleRemove(file, fileList) {
			console.log(file, fileList);
		},
		handlePreview(file) {
			console.log(file);
		},
		handleExceed(files, fileList) {
			if(res.errCode=='201'){
				this.$router.push({
					name:'/'
				})
				return;
			}
			console.log(files);
		},
		beforeRemove(file, fileList) {
			return this.$confirm(`确定移除 ${ file.name }？`);
		},
		handleAvatarSuccess(res, file){
			if(res.errCode=='201'){
				this.$router.push({
					name:'/'
				})
				return;
			}
			this.form.img = res.result;
		}
	},
	mounted() {
	}
}
</script>

<style>
</style>
